import React from 'react';
import detectIt from 'detect-it';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import { layout } from '@prisjakt/ui-base';

import ItemList from '../item-list';
import ListItemDnd from './list-item-dnd';
import DragIndicatorIcon from '../icons/drag-indicator';

import * as S from './styles';

const TYPE = 'list-item';

const listItemSource = {
  beginDrag(props) {
    return {
      id: props.id,
      originalIndex: props.findListItem(props.id).index,
      dragPreview: props.dragHandle,
    };
  },

  endDrag(props, monitor) {
    const { id: droppedId, originalIndex } = monitor.getItem();
    const didDrop = monitor.didDrop();

    if (!didDrop) {
      props.moveListItem(droppedId, originalIndex);
    }
  },
};

const listTarget = {
  canDrop() {
    return false;
  },
};

const listItemTarget = {
  hover(props, monitor) {
    const { id: draggedId } = monitor.getItem();
    const { id: overId } = props;

    if (draggedId !== overId) {
      const { index: overIndex } = props.findListItem(overId);
      props.moveListItem(draggedId, overIndex);
    }
  },

  drop(props) {
    props.handleDrop(props.listId);
  },
};

function dragCollect(connect) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
  };
}

function dropCollect(connect, monitor) {
  return {
    highlighted: monitor.canDrop(),
    hovered: monitor.isOver(),
    connectDropTarget: connect.dropTarget(),
  };
}

const DragDropListItem = DropTarget(
  TYPE,
  listItemTarget,
  dropCollect
)(DragSource(TYPE, listItemSource, dragCollect)(ListItemDnd));

class ListDnd extends React.Component {
  constructor(props) {
    super(props);

    this.dragHandle = React.createRef();

    this.state = {
      listItems: props.nodes,
    };

    this.moveListItem = this.moveListItem.bind(this);
    this.findListItem = this.findListItem.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.nodes.length !== state.listItems.length) {
      return {
        listItems: props.nodes,
      };
    }

    return null;
  }

  handleDrop(listId) {
    const ids = this.state.listItems.map(item => item.id);
    this.props.onOrder(ids, listId);
  }

  moveListItem(id, atIndex) {
    const { listItem, index } = this.findListItem(id);

    const newListItems = this.state.listItems;
    newListItems.splice(index, 1); // removes what is being dragged
    newListItems.splice(atIndex, 0, listItem); // inserts it into hover index

    this.setState({
      listItems: newListItems,
    });
  }

  findListItem(id) {
    const { listItems } = this.state;
    const listItem = listItems.filter(c => c.id === id)[0];

    return {
      listItem,
      index: listItems.indexOf(listItem),
    };
  }

  render() {
    const { props } = this;

    return props.connectDropTarget(
      <div>
        <ItemList
          {...props}
          nodes={this.state.listItems}
          render={itemProps => (
            <DragDropListItem
              item={itemProps.item}
              id={itemProps.item.id}
              moveListItem={this.moveListItem}
              findListItem={this.findListItem}
              handleDrop={this.handleDrop}
              handle={
                this.props.hasDragHandle ? (
                  <div>
                    <S.DragHandle ref={this.dragHandle}>
                      <DragIndicatorIcon
                        size={layout.dragAndDropHandleSize.mobile.value}
                      />
                    </S.DragHandle>
                  </div>
                ) : null
              }
              {...itemProps}
            />
          )}
        />
      </div>
    );
  }
}

const DropTargetContainer = DropTarget(TYPE, listTarget, dropCollect)(ListDnd);
export default DragDropContext(
  detectIt.hasTouch && !detectIt.hasMouse ? TouchBackend : HTML5Backend
)(DropTargetContainer);
